import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import ImageLayer from 'ol/layer/Image';
import ImageWMS from 'ol/source/ImageWMS';
import Overlay from 'ol/Overlay';
import {toStringHDMS} from 'ol/coordinate';
import {toLonLat} from 'ol/proj';
//import {defaults as defaultControls, Control} from 'ol/control';
import {defaults as defaultControls, ScaleLine} from 'ol/control';


var gebcoRasterSource = new ImageWMS({
  url: 'https://www.opendem.info/geoserver/opendem/wms',
  params: {'LAYERS': 'opendem:gebco_2021'},
  serverType: 'geoserver',
  crossOrigin: 'anonymous'
});

var gebcoRaster = new ImageLayer({
  source: gebcoRasterSource
});

var wmsLayerSource = new ImageWMS({
  url: 'https://www.opendem.info/geoserver/opendem/wms',
  params: {'LAYERS': 'opendem:countries_europe,opendem:gebco_2021_contours,opendem:marine_labels'},
  serverType: 'geoserver',
  crossOrigin: 'anonymous',
  attributions: ' Derived product from the <a href="https://www.gebco.net/data_and_products/gridded_bathymetry_data/">GEBCO 2021 Grid</a>, made with <a href="https://www.naturalearthdata.com/">NaturalEarth</a> by OpenDEM'
});

var wmsLayer = new ImageLayer({
  source: wmsLayerSource 
});

/*
var wmsLayerSource2 = new ImageWMS({
  url: 'https://maps.ngdc.noaa.gov/arcgis/services/web_mercator/undersea_features/MapServer/WMSServer',
  params: {'LAYERS': '0'},
  crossOrigin: 'anonymous',  
  attributions: ' , IHO-IOC GEBCO Gazetteer of Undersea Feature Names, <a href="https://www.gebco.net/data_and_products/gridded_bathymetry_data/">www.gebco.net</a>'
});

var wmsLayer2 = new ImageLayer({
  source: wmsLayerSource2,
   maxResolution: 4000
});
*/

/**
 * Elements that make up the popup.
 */
var container = document.getElementById('popup');
var content = document.getElementById('popup-content');
var closer = document.getElementById('popup-closer');


/**
 * Create an overlay to anchor the popup to the map.
 */
var overlay = new Overlay({
  element: container,
  autoPan: true,
  autoPanAnimation: {
    duration: 250
  }
});


/**
 * Add a click handler to hide the popup.
 * @return {boolean} Don't follow the href.
 */
closer.onclick = function() {
  overlay.setPosition(undefined);
  closer.blur();
  return false;
};

var view = new View({
  center: [0, 0],
  zoom: 1
});

var scaleControl = new ScaleLine({
});

var map = new Map({
  layers: [gebcoRaster, wmsLayer],
  //layers: [gebcoRaster, wmsLayer, wmsLayer2],
  target: 'map',
  overlays: [overlay],
  view: view,
      controls: defaultControls().extend([
    scaleControl
  ]),
});


map.on('singleclick', function(evt) {
  var viewResolution = /** @type {number} */ (view.getResolution());
  var url = gebcoRasterSource.getFeatureInfoUrl(
    evt.coordinate, viewResolution, 'EPSG:3857',
    {'INFO_FORMAT': 'application/json'});
  if (url) {
    fetch(url)
      .then(function (response) {
	  
	  return response.text();


	  })
      .then(function (json) {
		var depthclass = "" ; 
		 var fi = JSON.parse(json);
		 var palette = fi.features[0].properties.PALETTE_INDEX;
		 switch(palette) {
  case 2:
    depthclass = "25-50m"
    break;
	case 3:
    depthclass = "50-100m"
    break;
	case 4:
    depthclass = "100-250m"
    break;
	case 5:
    depthclass = "250-500m"
    break;
	case 6:
    depthclass = "500-750m"
    break;
	case 7:
    depthclass = "750-1000m"
    break;
	case 8:
    depthclass = "1000-1250m"
    break;
	case 9:
    depthclass = "1250-1500m"
    break;
	case 10:
    depthclass = "1500-1750m"
    break;
	case 11:
    depthclass = "1750-2000m"
    break;
	case 12:
    depthclass = "2000-2500m"
    break;
	case 13:
    depthclass = "2500-3000m"
    break;
	case 14:
    depthclass = "3000-35000m"
    break;
	case 15:
    depthclass = "3500-4000m"
    break;
	case 16:
    depthclass = "4000-4500m"
    break;
	case 17:
    depthclass = "4500-5000m"
    break;
	case 18:
    depthclass = "5000-5500m"
    break;
	case 19:
    depthclass = "5500-6000m"
    break;
	case 20:
    depthclass = "6000-65000m"
    break;	
	case 21:
    depthclass = "6500-7000m"
    break;
	case 22:
    depthclass = "7000-7500m"
    break;
	case 23:
    depthclass = "7500-8000m"
    break;
	case 24:
    depthclass = "8000-8500m"
    break;
	case 25:
    depthclass = "8500-90000m"
    break;
	case 26:
    depthclass = "9000-9500m"
    break;
	case 27:
    depthclass = "< -9500m"
    break;
	 default:
    depthclass = "noData"
  
}
		 
		   var coordinate = evt.coordinate;  
		     var hdms = toStringHDMS(toLonLat(coordinate));
  	  content.innerHTML = '<p>Depth class: '+depthclass+' at coodinate:</p><code>'+hdms+'</code>';
  overlay.setPosition(coordinate);
      });
  }
});